import React from 'react';

const ChartEmptyTableIcon = () => {
  return (
    <svg
      width='96'
      height='96'
      viewBox='0 0 96 96'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='15.4531'
        y='47.4199'
        width='13.1155'
        height='29.2339'
        fill='#E6E6E6'
      />
      <rect
        x='32.5312'
        y='27.75'
        width='13.1155'
        height='48.9029'
        fill='#E6E6E6'
      />
      <rect
        x='49.6094'
        y='52.7461'
        width='13.1155'
        height='23.9065'
        fill='#E6E6E6'
      />
      <path
        d='M8.07812 17.9141V77.6108H87.4486'
        stroke='#D2D2D2'
        strokeWidth='1.0677'
      />
      <rect
        x='66.6875'
        y='39.2227'
        width='13.1155'
        height='37.4307'
        fill='#E6E6E6'
      />
    </svg>
  );
};

export default ChartEmptyTableIcon;
